import React from 'react';
import {NavLink, Link, withRouter} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faSignOutAlt, faSignInAlt, faUsersCog, faHome, faUser} from '@fortawesome/free-solid-svg-icons';

import AdminGroupSelect from 'Components/Partials/AdminGroupSelect';

import User from 'Services/User';
import {asset, filterItemsByAccess} from 'Services/BaseHelpers';

class Header extends React.Component {
    /**
     * @var navItems
     * @type {string}
     */
    navItems = [
        // Pre auth
        // {
        //     to: "/login",
        //     icon: faSignInAlt,
        //     title: "Login",
        //     is_logged_out: true
        // },
        // Post auth
        {
            to: "/dashboard",
            title: "Home",
            is_logged_in: true
        },
/*        {
            to: "/registration",
            title: "Registration",
            is_logged_in: true,
            group: 'Group 2'
        },*/
        //process.env.MIX_API_BASE
        // {
        //     to: "/whos-who",
        //     title: "Who's Who",
        //     is_logged_in: true,
        //     group: 'Group 2'
        // },
        {
            to: "/survey",
            title: "Survey",
            is_logged_in: true,
            group: 'Group 2',
            survey: true, //process.env.MIX_SURVEY_ACTIVE,
        },
        {
            to: "/leaderboard",
            title: "Leaderboard",
            is_logged_in: true,
        },
        {
            to: "/tokyo",
            title: "Tokyo",
            is_logged_in: true,
        },
        {
            to: "/agenda",
            title: "Itinerary",
            is_logged_in: true,
        },
        {
            to: "/hotel",
            title: "Hotel",
            is_logged_in: true
        },
        {
            to: "/registration",
            title: "Registration",
            is_logged_in: true,
            group: 'Group 2'
        },
        // {
        //     to: "/register",
        //     title: "Register",
        //     is_logged_in: true
        // },
        // {
        //     to: "/whos-who",
        //     title: "Who's Who",
        //     is_logged_in: true
        // },
        {
            to: "/gallery",
            title: "Gallery",
            is_logged_in: true,
            group: 'Group 2'
        },
        {
            to: "/faq",
            title: "FAQs",
            is_logged_in: true
        },
        {
            to: "/admin",
            icon: faUsersCog,
            title: "Admin",
            is_admin: true,
            is_logged_in: true
        },
        {
            to: "/logout",
            icon: faSignOutAlt,
            title: "Logout",
            is_logged_in: true
        },
    ];

    /**
     * @var state
     * @type {{showOnMobile: boolean}}
     */
    state = {
        showOnMobile: false,
    };

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const {showOnMobile} = this.state;

        return (
            <div className="bg-white text-black px-8 select-none flex items-center flex-wrap lg:flex-nowrap">
                <Link to="/" className="py-2">
                    <img
                        src={asset('images/mini-logo.png')}
                        alt="Logo"
                        className="block w-28 align-self-center"
                    />
                </Link>

                <FontAwesomeIcon
                    icon={faBars}
                    size="2x"
                    onClick={() => this.setState({showOnMobile: !showOnMobile})}
                    className="block lg:hidden cursor-pointer ml-auto mr-2"
                />

                <div className={`${showOnMobile ? 'flex' : 'hidden lg:flex'} p-2 lg:p-0 w-full justify-between items-center flex-col lg:flex-row`}>
                    <div className="flex flex-col lg:flex-row items-center text-center lg:pl-8 gap-2">
                        {filterItemsByAccess(this.navItems.filter(item => !item.is_admin))
                            .map((navItem, i) => this.renderNavItem(navItem, i)) }
                    </div>

                    {User?.data?.is_admin && (
                        <div className="flex flex-col lg:flex-row items-center text-center lg:pl-8 gap-2">
                            {filterItemsByAccess(this.navItems.filter(item => item.is_admin))
                                .map((navItem, i) => this.renderNavItem(navItem, i)) }

                            {User?.data?.is_admin && window.base.features.groups &&
                                <AdminGroupSelect/>
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }

    /**
     * @method renderNavItem
     * @param {object} navItem
     * @param {integer} key
     * @returns {JSX.Element}
     */
    renderNavItem = (navItem, key) => {
        return (
            <NavLink
                key={key}
                className="font-arial uppercase font-bold flex flex-row justify-center items-center gap-2 bmw-condenced-regular px-2 py-2 lg:py-6 border-b-4 border-white h-full transition duration-200 hover:border-app-blue"
                activeClassName="border-app-blue !text-app-blue"
                to={navItem.to}
                exact={true}
            >
                {navItem.icon &&
                    <FontAwesomeIcon
                        icon={navItem.icon}
                        size="1x"
                    />
                }

                {navItem.title}
            </NavLink>
        );
    };
}

export default withRouter(Header);
